import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import {GridUtils} from '../../../../shared-utilities/utils-old/grid-utils-old/grid-utils';
import {NGPReport} from '../../../../shared-utilities/models-old/ngp-reports/ngp-report';
import {StockItem} from '../../../../shared-utilities/models-old/datastructures';
import {selectCurrentNavigationPage} from '../../../../features/user-access/user-stores-store/user-store.selectors';

@Component({
  selector: 'app-stock-manager-cell-renderer-multiple-barcodes',
  templateUrl: './stock-manager-cell-renderer-multiple-barcodes.component.html',
  styleUrls: ['./stock-manager-cell-renderer-multiple-barcodes.component.scss'],
  standalone: false,
})
export class StockManagerCellRendererMultipleBarcodesComponent implements ICellRendererAngularComp {

  selectedValues: string[] = [];
  params: ICellRendererParams;
  currentPage: string;

  constructor(
    private readonly store: Store,
  ) {
  }

  get selectedValuesLabel(): string {
    if (!this.selectedValues || this.selectedValues.length === 0) {
      return '';
    }

    const firstValue = this.selectedValues[0];
    const additionalCount = this.selectedValues.length - 1;

    return additionalCount > 0
      ? `${firstValue} + ${additionalCount} other${additionalCount > 1 ? 's' : ''}`
      : `${firstValue}`;
  }

  agInit(params: ICellRendererParams): void {
    this.store.select(selectCurrentNavigationPage).pipe(take(1)).subscribe((page: string) => {
      this.currentPage = page;
    });
    this.params = params;
    this.selectedValues = this.normalizeBarcodes(params.data?.[params.colDef.field] ?? params.value);
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onUndoChangesClick(): void {
    this.params = {...this.params};
    this.params.data = structuredClone(this.params.data);
    const field = this.params.colDef.field;
    const originalEntry = this.params.data.originalValue?.[field];
    const original = this.normalizeBarcodes(originalEntry?.value ?? []);
    this.params.data[this.params.colDef.field] = original;
    this.selectedValues = original;
    GridUtils.removeIsEditingFlagAndDispatch(
      this.params.data as NGPReport | StockItem,
      this.params.colDef.field,
      this.store,
      this.currentPage,
    );
    GridUtils.updateIsEditedAndForceRefresh(this.params);
  }

  areArraysEqual(): boolean {
    const field = this.params.column.getColDef().field;
    const current = this.normalizeBarcodes(this.params.data[field]);
    const original = this.normalizeBarcodes(this.params.data.originalValue[field].value);
    return !this.arraysAreEqual(current, original);
  }

  formatSelectedValues(values: string[]): string {
    return values.map((value: string) => `${value}`).join(', \n');
  }

  private normalizeBarcodes(value: unknown): string[] {
    if (Array.isArray(value)) {
      return value
        .map((barcode: string | number) => String(barcode).trim())
        .filter((barcode: string) => barcode.length > 0);
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      return value
        .split(',')
        .map((barcode: string) => barcode.trim())
        .filter((barcode: string) => barcode.length > 0);
    }
    return [];
  }

  private arraysAreEqual(arr1: string[], arr2: string[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }
    return arr1.every((value: string, index: number) => value === arr2[index]);
  }

}
